import {get} from 'lodash'
import {createLogger as createPowtoonLogger} from 'powtoon-commons/logger'
import {getCorePlayerImports} from 'powtoon-html-player/src/CorePlayerImports'
import cookie from 'cookie'
import uuid from 'powtoon-commons/utils/uuid'
import webvarsConfigurationService from '../services/webvarsConfigurationService'
import {isDev} from '../services/env'

const {getWebVar} = webvarsConfigurationService

const logzioId = getWebVar('logzioId')
const logzioMetricsId = getWebVar('logzioMetricsId')
const logzioUrl = getWebVar('logzioUrl')
const logLevel = getWebVar('min_log_level')
const appLevel = getWebVar('appLevel')
let userId = getWebVar('userId')

let {visitorid: visitorId, sessionid: sessionId} = cookie.parse(document.cookie)
let powtoonId = get(window.location.hash.match(/\/edit\/(\w*).?$/), '[1]', '')

const data = {
  logzioId,
  logzioMetricsId,
  logzioUrl,
  appName: process.env.ENTRY_POINT_NAME,
  appVersion: process.env.BUILD_IDENTIFIER,
  appLevel: appLevel || 'n.a',
  userAgent: window.navigator.userAgent,
  tabId: uuid(),
  client_ip: getWebVar('clientIP'),
  get powtoonId() {
    return powtoonId || 'n.a'
  },
  set powtoonId(value) {
    powtoonId = value
  },
  get userId() {
    return userId || 'n.a'
  },
  set userId(value) {
    userId = value
  },
  get sessionId() {
    return sessionId || 'n.a'
  },
  set sessionId(value) {
    sessionId = value
  },
  get visitorId() {
    return visitorId || 'n.a'
  },
  set visitorId(value) {
    visitorId = value
  },
  corePlayerVersion: null
}

const logConfig = {
  logLocally: isDev,
  logRemotely: !!logzioId,
  logLevel
}

getCorePlayerImports().then(CorePlayerImports => {
  data.corePlayerVersion = CorePlayerImports.getVersion()
})

interface SetUserIdentityProps {
  userId: string
  powtoonId: string
  visitorId: string
  sessionId: string
}

export const setUserIdentity = ({userId, powtoonId, sessionId, visitorId}: SetUserIdentityProps) => {
  data.userId = userId
  data.powtoonId = powtoonId
  data.sessionId = sessionId
  data.visitorId = visitorId
}

export const createLogger = (moduleName: string, loggerName = '') => {
  return createPowtoonLogger({moduleName, loggerName}, data, logConfig)
}
